module.exports = __webpack_public_path__ + "static/media/Templates.8165efc6.svg";